/**
 * Agency Details page module.
 * Refactored to use shared utilities.
 */

import { escapeHtml, getAntiForgeryToken, showNotification } from '../lib/helpers';
import { postJson } from '../lib/api-client';

document.addEventListener('DOMContentLoaded', () => {
    const container = document.getElementById('agency-details-container') as HTMLElement | null;
    if (!container) return;

    const agencyId = parseInt(container.dataset.agencyId || '0', 10);
    const urlCreateOffice = container.dataset.urlCreateOffice || '';

    const form = document.getElementById('create-office-form') as HTMLFormElement | null;
    const tbody = document.getElementById('offices-tbody') as HTMLTableSectionElement | null;
    const noOfficesRow = document.getElementById('no-offices-row') as HTMLTableRowElement | null;
    const addOfficeCollapse = document.getElementById('addOfficeForm') as HTMLElement | null;

    if (!form || !tbody) return;

    form.addEventListener('submit', async (e) => {
        e.preventDefault();

        const formData = new FormData(form);
        const office = {
            agencyId: agencyId,
            city: formData.get('City') as string,
            address: formData.get('Address') as string,
            phone: formData.get('Phone') as string,
            email: formData.get('Email') as string,
            isMain: formData.get('IsMain') === 'on'
        };

        try {
            const result = await postJson(urlCreateOffice, office);

            if (result.success && result.data) {
                // Remove "no offices" row if present
                if (noOfficesRow) {
                    noOfficesRow.remove();
                }

                // Add new row to table
                addOfficeRow(result.data);

                // Reset form
                form.reset();

                // Collapse the form
                if (addOfficeCollapse) {
                    const bsCollapse = (window as any).bootstrap.Collapse.getOrCreateInstance(addOfficeCollapse);
                    bsCollapse.hide();
                }

                showNotification('Office created successfully!', 'success');
            } else {
                showNotification(result.message || 'Failed to create office.', 'error');
            }
        } catch (error) {
            console.error('Error creating office:', error);
            showNotification('An error occurred while creating the office.', 'error');
        }
    });

    function addOfficeRow(office: any) {
        const row = document.createElement('tr');
        row.setAttribute('data-office-id', office.id);

        const mainBadge = office.isMain
            ? '<span class="badge bg-success">Yes</span>'
            : '<span class="badge bg-secondary">No</span>';

        row.innerHTML = `
            <td>${escapeHtml(office.city || '')}</td>
            <td>${escapeHtml(office.address || '')}</td>
            <td>${escapeHtml(office.phone || '-')}</td>
            <td>${escapeHtml(office.email || '-')}</td>
            <td>${mainBadge}</td>
            <td>
                <a href="/Office/Edit/${office.id}" class="btn btn-sm btn-outline-secondary">Edit</a>
            </td>
        `;

        tbody!.appendChild(row);
    }
});
